/* eslint function-paren-newline: 0 */
const _ = require('lodash');

module.exports.findImage = (images
/*: ?Array<string>*/
, type
/*: string*/
) => {
  if (!images) return undefined;
  return images.find(imageId => imageId.split('_')[0] === type) || null;
};

module.exports.findImages = (images
/*: ?Array<string>*/
, type
/*: string*/
) => {
  if (!images) return undefined;
  return images.filter(imageId => imageId.split('_')[0] === type) || null;
};

module.exports.serializeImages = (images
/*: Array<?string>*/
) => {
  if (!images) return undefined;
  if (images.some(id => id !== undefined)) return _.compact(images);
  return undefined;
};